<template>
  <div class="container">
    <div class="row vertical-center">
      <div class="col-12">
        <div id="pst-viewport" ref="viewport"></div>
      </div>
    </div>
  </div>
</template>


<script>
import participant from "../modules/Participant"
import Router from "../router"
import PSYAPI from "../modules/API"
import PST from "../modules/vue-pst-plugin"
const http = require("https")

const sendToSSK = (ptp) => {
  return new Promise((resolve, reject) => {
    let data = JSON.stringify(ptp)
    const post = http.request(
      {
        //host: "swiss-skills.pimstage.ch",
        //host: "missionfuture.w-vision.ch",
        host: "missionfuture.swiss-skills.ch",
        path: "/mfp/webservice/psyfiers/exam",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key":
            "a10b3e8a6be3fe55d3ec19365aac07e68a6f24d5438cd25c50293ae50f39486c",
          Accept: "*/*",
          "Accept-Encoding": "gzip, deflate, br",
          "Access-Control-Allow-Origin": "*",
          "Cache-Control": "no-cache",
          Connection: "keep-alive",
          "Content-Length": data.length,
          Host: "missionfuture.w-vision.ch",
          "X-Php-Ob-Level": "1",
        },
        rejectUnauthorized: false,
      },
      (response) => {
        if (response.statusCode === 200) {
          resolve()
        } else {
          reject({
            error: "Unexpected http response code",
            code: response.statusCode,
          })
        }
      }
    )

    if (post) {
      post.write(data)
      post.end()
      post.on("error", (err) => {
        reject(err)
      })
    } else {
      reject({
        error: "No POST request created",
        code: 500,
      })
    }
  })
}

/**
window.__getAge = function() {
  return participant.age;
};

window.__getSex = function() {
  return participant.sex;
};

window.__setResult = function(result) {
  participant.result = result.type;
  participant.e = result.e;
  participant.s = result.s;
  participant.n = result.n;
  participant.t = result.t;
  participant.f = result.f;
  participant.j = result.j;
  participant.sex = participant.sex.toUpperCase();
  console.log(participant);
  PSYAPI.participant.create(participant, status => {
    if (status === 200) {
      PSYAPI.tan.invalidateTan(
        participant.tan,
        participant.project.id,
        function() {
          Router.push("/generate");
        }
      );
    } else {
      alert("An error occured: HTTP-" + status);
    }
  });
};
*/
export default {
  name: "Pst",
  data() {
    return {
      p: participant,
    }
  },
  mounted() {
    window.scrollTo(0, 1)
    this.$parent.$refs.header.classList.add("hidden")
    PST.init({
      viewport: "pst-viewport",
      locale: this.$i18n.locale,
      baseUrl: "/proxy",
      success: (status, result) => {
        participant.result = result.type
        participant.e = result.e
        participant.s = result.s
        participant.n = result.n
        participant.t = result.t
        participant.f = result.f
        participant.j = result.j
        participant.sex = participant.sex.toUpperCase()
        sendToSSK({
          tan: participant.tan,
          firstname: participant.firstname,
          lastname: participant.lastname,
          email: participant.email,
          dob: participant.dob,
          postcode: participant.postcode.id,
          sex: participant.sex.toUpperCase(),
          language: this.$i18n.locale,
          e: result.e,
          s: result.s,
          n: result.n,
          t: result.t,
          f: result.f,
          j: result.j,
        })
          .then(() => {
            PSYAPI.tan.invalidateTan(
              participant.tan,
              participant.project.id,
              function () {
                Router.push("/generate")
              }
            )
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err)
            alert("An error occured: HTTP-" + err.code)
          })
        /*PSYAPI.participant.create(participant, status => {
          if (status === 200) {
            PSYAPI.tan.invalidateTan(
              participant.tan,
              participant.project.id,
              function() {
                Router.push("/generate")
              }
            )
          } else {
            alert("An error occured: HTTP-" + status)
          }
        })*/
      },
    })
  },
  created() {
    if (participant.tan === null) {
      this.$router.push("/tan")
    }
  },
  destroyed() {
    this.$parent.$refs.header.classList.remove("hidden")
  },
}
</script>

<style scoped>
#pst-viewport {
  display: block;
  height: auto;
  width: 100%;
  min-height: 400px;
}

.hidden {
  display: none;
}

.container {
  max-width: 1024px !important;
}

@media screen and (max-width: 770px) {
  #pst-viewport {
    display: block;
    height: auto;
    width: 100%;
    min-height: 200px;
  }
}
</style>